/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RequestInitiator {
  MMB = 'MMB',
  CHECK_IN = 'CHECK_IN',
  DEEPLINK_MMB = 'DEEPLINK_MMB',
  DEEPLINK_CHECK_IN = 'DEEPLINK_CHECK_IN',
  REFUND_FORM = 'REFUND_FORM',
  UNKNOWN = 'UNKNOWN'
}

